module.exports = "/build/images/save.svg?915f7d34777bbd07bb4f45de6d64d2ab";


//////////////////
// WEBPACK FOOTER
// ./yii2/frontend/frontend-assets/src/_static/images/save.svg
// module id = 4509
// module chunks = 0